import { releaseAnnouncementActionTypes as actionTypes } from '../ActionTypes/releaseAnnouncementActionTypes';
import type { ActiveAnnouncement, AnnouncementState } from '../Components/Announcement/Announcement.types';

type AnnouncementAction = { type: typeof actionTypes.STORE_ACTIVE_ANNOUNCEMENT; data: ActiveAnnouncement | null | undefined };

export const initialState: AnnouncementState = {
    major: null,
    minor: null,
};

export default function AnnouncementReducer(state: AnnouncementState = initialState, action: AnnouncementAction): AnnouncementState {
    switch (action.type) {
        case actionTypes.STORE_ACTIVE_ANNOUNCEMENT:
            return {
                major: action.data?.major ?? null,
                minor: action.data?.minor ?? null,
            };

        default:
            return state;
    }
}
